/* eslint eqeqeq: 0 */
import { Record } from "immutable";
import store from "../../reducers/store";

export const STATUS_STOP = "stop";
export const STATUS_START = "start";
export const STATUS_MODERATE = "moderation";
export const STATUS_SUSPEND = "pause";
export const STATUS_ARCHIVE = "archive";
export const STATUS_REJECTED = "reject";

const CampaignStatRecord = new Record({
  id: undefined,
  name: undefined,
  status: undefined,
  monetization: false,
  stat: {
    ctr: 0,
    clicks: 0,
    shows: 0,
    rpm: 0,
    vshows: 0,
    vctr: 0,
    vrpm: 0,
    vshows_percent: 0,
    revenue: 0,
    system_profit_new: 0,
    system_profit_other: 0,
    profit_new: 0,
    profit_other: 0
  }
});

export default class CampaignStat extends CampaignStatRecord {
  isActive() {
    return this.status == STATUS_START || this.status == STATUS_SUSPEND;
  }

  isModerating() {
    return this.status == STATUS_MODERATE;
  }

  isRejected() {
    return this.status == STATUS_REJECTED;
  }

  isStopped() {
    return this.status == STATUS_STOP || this.status == STATUS_ARCHIVE;
  }

  // eslint-disable-next-line consistent-return
  getStatusName() {
    const { config } = store.getState();

    if (this.isActive()) {
      if (config.isAdwile()) {
        if (this.status == STATUS_START) {
          return "Активный";
        } else if (this.status == STATUS_SUSPEND) {
          return "Приостановлена";
        }
      }

      return "Активный";
    } else if (this.isModerating()) {
      return "На проверке";
    } else if (this.isRejected()) {
      return "Отклонен";
    } else if (this.isStopped()) {
      return "Отключен";
    }
  }

  get statusLabel() {
    return this.getStatusName();
  }
}
